var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "787px",
    height: "787px",
    viewBox: "0 0 787 787",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Chat") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chat",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.000000, 158.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2073249,53.1714085 C13.2589844,24.8168266 37.4247111,-4.07940106 63.9113295,0.476736498 L64.714635,0.625075782 L141.823452,15.8378395 C154.532836,18.3441569 164.438064,28.1680963 167.916808,41.6618395 L168.034212,42.12859 L168.753959,45.0656381 C172.401224,59.957027 167.741991,74.9929583 158.685114,85.5602851 L165.927169,127.318838 C166.611996,131.26903 162.331826,135.097539 158.776768,133.709742 L111,113.023527 L129.427946,99.9999111 C127.477263,100.004387 125.50276,99.8398903 123.515829,99.4929749 L122.770169,99.3543045 L52.3999762,85.471904 C36.6125417,82.3570053 24.3398681,70.0441118 20.2073249,53.1714085 Z",
    id: "Path",
    fill: "#1C7EC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4011026,99.4718743 L103.768799,113.354303 C131.459629,118.817445 157.00117,88.6561198 149.75357,59.0655258 L149.033808,56.1284716 C145.664924,42.3947544 135.678231,32.3738031 122.832486,29.8386722 L45.7170239,14.6248726 C18.9168993,9.33757232 -5.80991187,38.5302624 1.20676441,67.1723176 C5.34139515,84.0440506 17.613331,96.3569692 33.4011026,99.4718743",
    id: "Fill-188",
    fill: "#30A5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0529241,68.7585019 C93.6255121,62.2484736 98.5418714,57.9753803 104.030819,59.2135025 C109.519766,60.4516247 113.51801,66.7324838 112.945422,73.2414981 C112.382706,79.7515264 107.466347,84.0246197 101.9774,82.7864975 C96.4785801,81.5483753 92.4902083,75.2685303 93.0529241,68.7585019 Z M60.0537599,62.7585019 C60.6214076,56.2484736 65.5347687,51.9753803 71.0276241,53.2135025 C76.5194922,54.4516247 80.5098088,60.7324838 79.9470972,67.2414981 C79.3745134,73.7515264 74.4631267,78.0246197 68.9712586,76.7864975 C63.4784032,75.5483753 59.4861122,69.2685303 60.0537599,62.7585019 Z M30.0537491,56.7585019 C30.6214008,50.2484736 35.5357839,45.9753803 41.0276909,47.2135025 C46.5215724,48.4506106 50.5138917,54.7314697 49.9462399,61.2414981 C49.377601,67.7515264 44.4642051,72.0246197 38.9713109,70.7864975 C33.4794038,69.5483753 29.4860974,63.2675162 30.0537491,56.7585019 Z",
    id: "Shape",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.ab0cefc2e1db7b2f8627840c63dffcad.svg";
export { ForwardRef as ReactComponent };